import promotionsApi from '../_promotions-api.js';

export const getPromotions = async ({ commit, dispatch, state }, lazy) => {
  if (!state.promotionsCollection.initialized || lazy) {
    let response = await dispatch('async', () => promotionsApi.getPromotions(state.promotionsCollection));
    commit('setPromotions', response);
    return response;
  }
}

export const searchPromotions = ({ commit, dispatch }, query) => {
  commit('searchPromotions', query);
  commit('resetPromotions');
  return dispatch('getPromotions');
}

export const sortPromotions = ({ commit, dispatch }, column) => {
  commit('sortPromotions', column);
  commit('resetPromotions');
  return dispatch('getPromotions');
}

export const getPromotion = async ({ state, dispatch, commit }, promotionId) => {
  commit('updateState', { object: state, property: 'currentPromotion', value: {} });
  let response = await dispatch('async', () => promotionsApi.getPromotion(promotionId))
  commit('setCurrentPromotion', response.data);
  return response;
}

export const toggleActivatePromotion = async ({ commit, dispatch }, { promotion, activated }) => {
  await dispatch('async', () => promotionsApi.toggleActivated(promotion, activated))
  commit('activatePromotion', { promotion, activated });
  commit('addNotification', `Coupon ${promotion.code} ${activated ? 'enabled' : 'disabled'}`)
  return dispatch('getPromotions');
}

export const saveOrUpdatePromotion = async ({ commit, dispatch, state }) => {
  let response = await dispatch('async', () => promotionsApi.saveOrUpdatePromotion(state.currentPromotion))
  commit('resetPromotions');
  return response;
}

export const removePromotion = async ({ commit, dispatch }, promotion) => {
  try {
    let response = await dispatch('async', () => promotionsApi.removePromotion(promotion))
    commit('addNotification', `Coupon ${promotion.code} deleted.`);
    commit('removePromotion', promotion);
    return response;
  } catch (e) {
    commit('addNotification', `Coupon was not found.`);
    commit('resetPromotions');
    dispatch('getPromotions');
    throw e;
  }
}